const RAW_VARIABLES_URL = process.env.API_URL + '/raw-variables/';

const getRawVariables = (context) => {
  return context.$http.get(RAW_VARIABLES_URL);
};

const updateRawVariable = (context, rawVariable) => {
  return context.$http.put(RAW_VARIABLES_URL, rawVariable);
};

export default {
  getRawVariables,
  updateRawVariable
};



// WEBPACK FOOTER //
// ./src/api/rawVariables/rawVariablesHttp.js